<template>
  <v-card flat>
    <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
      <v-row class="no-gutters">
        <v-col cols="12" sm="6" md="9" lg="10">
          <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search here ..." single-line solo
            hide-details></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2">
          <ul>
            <li>
              <span>Master:</span>
              <span>{{ masterOrdersCount }}</span>
            </li>
            <li>
              <span>Sub-Order:</span>
              <span>{{ subOrdersCount }}</span>
            </li>
          </ul>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12">
          <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
            <v-sheet class="transactionTable liveTradeTable walletTable pb-3" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'
              ">
              <v-data-table :headers="headers" :items="managerInvestorLiveOrders" :search="search" :items-per-page="6"
                :single-expand="singleExpand" :item-key="'manager_order'" :expanded.sync="expanded" show-expand>

                <template v-slot:item.order="{ item }">
                  <v-icon small color="#FF567F" class="mr-1 align-start">mdi-star-outline</v-icon>
                  Master
                </template>

                <template v-slot:item.orderNo="{ item }">
                  {{ item?.manager_order }}
                </template>

                <template v-slot:item.loginAcc="{ item }">
                  {{ item?.manager_account }}
                </template>

                <template v-slot:item.Action="{ item }">
                  <span>
                    {{
                      item?.Action === 1 ? "Sell" : "Buy"
                    }}
                  </span>
                </template>

                <template v-slot:item.TimeCreate="{ item }">
                  <span>
                    {{
                      formatMySQLDate(item?.TimeCreate)
                    }}
                  </span>
                </template>

                <template v-slot:item.PriceOpen="{ item }">
                  <span>
                    {{ item?.PriceOpen?.toFixed(2) }}
                  </span>
                </template>

                <template v-slot:item.PriceSL="{ item }">
                  <span>
                    {{ item?.PriceSL?.toFixed(2) }} -
                    {{ item?.PriceTP?.toFixed(2) }}
                  </span>
                </template>

                <template v-slot:item.Volume="{ item }">
                  <span class="profit-text-color">
                    {{ (item?.Volume / 10000).toFixed(2) }}
                  </span>
                </template>

                <template v-slot:item.Comment="{ item }">
                  <v-tooltip top color="#000">
                    <template v-slot:activator="{ on }">
                      <v-btn color="#b4c2d1" class="text-capitalize pa-0 details-btn text-decoration-underline"
                        :ripple="false" plain small title v-on="on">
                        detail
                      </v-btn>
                    </template>
                    <span>{{ item?.Comment || 'N/A' }}</span>
                  </v-tooltip>
                </template>

                <template v-slot:item.Profit="{ item }">
                  <span>
                    {{ item?.Profit.toFixed(2) }}
                  </span>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length" class="pa-0">
                    <v-data-table :headers="headers" :items="item?.investorOrders" hide-default-footer
                      hide-default-header class="childTable mx-0">

                      <template v-slot:item.order="{ item }">
                        <v-icon small color="#D19909" class="mr-1 align-start">mdi-arrow-right-bottom</v-icon>
                        Sub-Order
                      </template>

                      <template v-slot:item.orderNo="{ item }">
                        {{ item?.investor_order }}
                      </template>

                      <template v-slot:item.loginAcc="{ item }">
                        {{ item?.investor_account }}
                      </template>

                      <template v-slot:item.Action="{ item }">
                        <span>
                          {{
                            item?.Action === 1 ? "Sell" : "Buy"
                          }}
                        </span>
                      </template>

                      <template v-slot:item.TimeCreate="{ item }">
                        <span>
                          {{
                            formatMySQLDate(item?.TimeCreate)
                          }}
                        </span>
                      </template>

                      <template v-slot:item.PriceSL="{ item }">
                        <span>
                          {{ item?.PriceSL?.toFixed(2) }} -
                          {{ item?.PriceTP?.toFixed(2) }}
                        </span>
                      </template>

                      <template v-slot:item.PriceOpen="{ item }">
                        <span>
                          {{ item?.PriceOpen?.toFixed(2) }}
                        </span>
                      </template>

                      <template v-slot:item.Volume="{ item }">
                        <span class="profit-text-color">
                          {{ (item?.Volume / 10000).toFixed(2) }}
                        </span>
                      </template>

                      <template v-slot:item.Comment="{ item }">
                        <v-tooltip top color="#000">
                          <template v-slot:activator="{ on }">
                            <v-btn color="#b4c2d1" class="text-capitalize pa-0 details-btn text-decoration-underline"
                              :ripple="false" plain small title v-on="on">
                              detail
                            </v-btn>
                          </template>
                          <span>{{ item?.Comment || 'N/A' }}</span>
                        </v-tooltip>
                      </template>

                      <template v-slot:item.Profit="{ item }">
                        <span>
                          {{ item?.Profit.toFixed(2) }}
                        </span>
                      </template>
                    </v-data-table>
                  </td>
                </template>
              </v-data-table>
            </v-sheet>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { MAM__ACTIONS } from "@/store/action-types";
import { formatMySQLDate } from "@/_helpers/formateDate";

export default {
  data() {
    return {
      search: "",
      expanded: [],
      singleExpand: true,
      headers: [
        { text: "Order", value: "order"},
        { text: "Type", value: "Action" },
        { text: "Order No", value: "orderNo" },
        { text: "Login", value: "loginAcc" },
        { text: "Symbol", value: "Symbol" },
        { text: "Comment", value: "Comment" },
        { text: "Lots", value: "Volume" },
        { text: "Open Time", value: "TimeCreate" },
        { text: "Open Price", value: "PriceOpen" },
        { text: "SL-TP", value: "PriceSL" },
        { text: "Profit", value: "Profit" },
        { text: "Account Status", value: "data-table-expand" },
      ],
    };
  },

  watch: {
    managerInvestorLiveOrders() {
      this.expanded = [];
    }
  },

  computed: {
    ...mapState("mam", ["managerInvestorLiveOrders"]),
    masterOrdersCount() {
      return this.managerInvestorLiveOrders.length;
    },

    subOrdersCount() {
      return this.managerInvestorLiveOrders.reduce((total, order) => {
        return total + (order.investorOrders?.length || 0);
      }, 0);
    }
  },

  methods: {
    formatMySQLDate,
    ...mapActions("mam", [MAM__ACTIONS.GETLIVEORDERS]),
  },

  async mounted() {
    await this[MAM__ACTIONS.GETLIVEORDERS](
      this.$route.query.account
    );
  },
};
</script>
